import attachFastClick from './assets/js/fastclick.js'
attachFastClick.attach(document.body)
import './service.js'
import * as common from './common.js'

// require('jquery-lazyload')
import './assets/js/swiper.min.js'
// import './assets/js/jquery.cookie.js'
import './assets/js/jquery.qrcode.min.js'
// import './assets/js/toast-min.js'

// require('lrz')
import 'lrz/dist/lrz.all.bundle.js'
import Vue from 'vue'
window.Vue = Vue
import routerConfig from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)
import App from './App'
// import Signin from './components/Signin.vue'
import * as filter from './filter'

import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import store from './vuex/store'
// import Vuex from 'vuex'
// import VueAsyncData from 'vue-async-data'
Vue.use(VueResource)
Vue.use(VueRouter)
// Vue.use(Vuex)

// Vue.use(jquery)
// Vue.use(VueAsyncData)

Vue.http.options.emulateJSON = true

// 全局转圈圈
// Vue.http.interceptors.push((request, next) => {
//   MintUI.Indicator.open()
//   // continue to next interceptor
//   next((response) => {
//     MintUI.Indicator.close()
//   })
// })

const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: routerConfig
})

router.beforeEach((to, from, next) => {
  let toPath = to.path
  if (toPath.indexOf('?time=') != -1) {
    toPath = to.path.substr(0, to.path.indexOf('?time='))
  }
  // let path = router.$route.path
  // Indicator.close()
  // $('body').css('overflow', 'auto')
  if (toPath.indexOf('/signin?time=') == -1 && toPath != '/signin') {
    try {
      JSON.parse(window.localStorage['basic_login_data'])
      JSON.parse(window.localStorage['login_data'])
      next()
    } catch (e) {
      console.log('router.beforeEach：强转错误' + e)
      window.localStorage.clear()
      router.push('/signin')
    }
  } else {
    next()
  }
})

$(function () {
  var b = window.browser()
  // console.log(b.chrome)
  if (b.chrome || b.android) {
    $('#app-wrap').addClass('android-wrap')
  }
})

function checkConnection () {
  var networkState = navigator.connection.type
  if (networkState == 'none') {
    if (router._currentRoute.path != '/networkLess' && router._currentRoute.path.indexOf('/networkLess?time=') == -1) {
      router.push('/networkLess')
    }
  } else {
    if (router._currentRoute.path == '/networkLess' || router._currentRoute.path.indexOf('/networkLess?time=') != -1) {
      window.history.go(-1)
    }
  }
}

// 过滤器 --- 几天前、几小时前.....
Vue.filter('dateDiff', filter.dateDiff)

if (common.isApp) {
  document.addEventListener('deviceready', function () {
    document.addEventListener('offline', checkConnection, false)
    document.addEventListener('online', checkConnection, false)
    new Vue({
      store,
      router,
      el: '#app',
      render: h => h(App)
    })
  }, false)
} else {
  new Vue({
    store,
    router,
    el: '#app',
    render: h => h(App)
  })
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/main.js